export default __webpack_public_path__ + "static/media/img1.50d19601.jpg";